module.exports = __webpack_public_path__ + "img/ig-icon-dark.1ec37e7.svg";